<nav [attr.aria-label]="'common.breadcrumbs' | cxTranslate" tabindex="-1">
  <ol [attr.aria-label]="'common.breadcrumbs' | cxTranslate">
    <li *ngFor="let crumbsCategory of crumbsCategory$ | async; let last = last">
      <a
        *ngIf="!last; else lastItem"
        [attr.aria-label]="'navigation.navigateTo' | cxTranslate: { nav: crumbsCategory.name }"
        [routerLink]="crumbsCategory.url"
        [innerHTML]="crumbsCategory.name"
      >
      </a>
      <ng-template #lastItem>
        <span class="cx-visually-hidden" aria-live="polite" aria-atomic="true">
          {{ lastestTitle$ | async }}
        </span>
        <span>{{ crumbsCategory.name || (title$ | async) }}</span>
      </ng-template>
    </li>
  </ol>
</nav>
